/** Get Summary Dashboard data */
export const SEARCH_MAC_API_SUCCESS = "SEARCH_MAC_API_SUCCESS";
export const SEARCH_MAC_API_FAIL = "SEARCH_MAC_API_FAIL";
export const GET_MAC_ID = "GET_MAC_ID";
